import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface ContactsHeaderProps {
  onAddContact: () => void;
}

export const ContactsHeader = ({ onAddContact }: ContactsHeaderProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{t("companies.detail.tabs.contacts")}</h3>
      <Button 
        onClick={onAddContact}
        className="bg-[#5a7ebf] hover:bg-[#5a7ebf]/90"
      >
        <Plus className="h-4 w-4 mr-2" />
        {t("companies.contacts.addContact")}
      </Button>
    </div>
  );
};
